import SetNamespace from './SetNamespace';

export default SetNamespace;
